import { render } from "./Applyfor.vue?vue&type=template&id=12b5661e&scoped=true&ts=true"
import script from "./Applyfor.vue?vue&type=script&lang=ts"
export * from "./Applyfor.vue?vue&type=script&lang=ts"

import "./Applyfor.vue?vue&type=style&index=0&id=12b5661e&lang=less&scoped=true"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b5661e"]])

export default __exports__